import { render, staticRenderFns } from "./SingleAnswer.vue?vue&type=template&id=bef43600&scoped=true&"
import script from "./SingleAnswer.vue?vue&type=script&lang=js&"
export * from "./SingleAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SingleAnswer.vue?vue&type=style&index=0&id=bef43600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef43600",
  null
  
)

export default component.exports